import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Intervention() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Professional%20technician%20installing%20a%20new%20white%20roller%20shutter%20pull%20cord%20and%20pulley%20mechanism%20inside%20a%20shutter%20box%20with%20clean%20tools%20and%20hands%20working%20in%20a%20modern%20French%20apartment%20warm%20daylight%20professional%20service%20photography&width=700&height=520&seq=cord-int&orientation=landscape" alt="Installation d'un nouveau cordon sur volet roulant à Strasbourg" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-5">
              En quoi consiste l&apos;intervention
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le remplacement d&apos;un cordon ou d&apos;un enrouleur de volet roulant commence par un diagnostic précis du mécanisme. Nos techniciens retirent le cordon usé ou cassé et inspectent l&apos;état de l&apos;enrouleur. Nous vérifions que le mécanisme n&apos;est pas bloqué et que le réenroulement fonctionne correctement avant de poser les nouvelles pièces.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nous installons un cordon neuf adapté aux dimensions de votre volet, avec la tension correcte pour un enroulement optimal. L&apos;enrouleur est remplacé si nécessaire, avec vérification du bon réenroulement et de l&apos;absence de jeu. Nous contrôlons la tension du cordon à chaque cycle de montée et descente.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-8">
              Enfin, nous testons le bon fonctionnement du volet : montée, descente et arrêt en position intermédiaire. Nous vérifions que le cordon ne patine pas et que l&apos;enrouleur réenroule correctement. L&apos;intervention dure généralement moins d&apos;une heure. Nous proposons des cordons et enrouleurs de qualité avec garantie.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}